import React from 'react';
import { formatNumber, returnColor } from '../../utils/functions';
import './progressring.scss';

function ProgressRing({ current, total, unitOfMeasure }) {
  const percent = current / total;
  const color = returnColor(percent);
  return (
    <div className="circle-wrap" style={{ '--degR': (current / total) * 100, '--colorR': color }}>
      <div className="circle">
        <div className="mask full">
          <div className="fill"></div>
        </div>
        <div className="mask half">
          <div className="fill"></div>
        </div>
        <div className="inside-circle">
          <p>{formatNumber(current, 0)}</p>
          <span>{unitOfMeasure || 'points'}</span>
        </div>
      </div>
    </div>
  );
}

export default ProgressRing;
